<template>
  <div class="m-0 p-0">
    <vue-confirm-dialog></vue-confirm-dialog>
    <div class="row m-0" v-show="!showSliderView">
      <div class="col-xl-9 col-lg-9 col-md-9 pr-0 pl-1 pl-xl-2">
        <div class="gallery-slider-container">
          <div class="row m-0 reverse-on-m">

            <div class="col-xl-6 col-lg-6 screen-height col-md-6 dirtyoverlay" v-if="$store.state.photo.dirty" style="display:flex;
              width:100%;
              height:100%;
              align-content: center;
              align-items: center;
              justify-content: center;
              background-color: rgba(0,0,0, 0.5);
              color: #fff;
              font-size: 2rem;
              position:absolute; z-index:100;
              margin-left:-15px;
">Ungespeicherte Änderungen<br />
              Bearbeitung speichern oder abbrechen.
            </div>
            <div class="col-xl-6 col-lg-6 position-relative photos-docu screen-height col-md-6 pt-2" :class = "$store.state.photo.dirty?'nooverflow':''" v-bind:style="isSelecteAble ? 'padding-bottom:70px' : ''">

<!--              <div class="row py-1">-->
<!--                <div class="col-xl-3 pr-lg-0 text-xl-left text-center">-->
<!--                  <span class=" font-10" v-if="$store.state.photo.LEnd < $store.state.photo.filtered">{{$store.state.photo.LStart}} bis {{($store.state.photo.LEnd )}} von  {{($store.state.photo.filtered)}} Fotos</span>-->
<!--                  <span class=" font-10" v-if="$store.state.photo.LEnd > $store.state.photo.filtered">{{$store.state.photo.LStart}} bis {{($store.state.photo.filtered )}} von  {{($store.state.photo.filtered)}} Fotos</span>-->
<!--               </div>-->
<!--                <div class="col-xl-6 text-center">-->

<!--                  <div class="p-1">-->
<!--                    <sliding-pagination-->
<!--                      :current="$store.state.photo.page"-->
<!--                      :total="$store.state.photo.TPage"-->
<!--                      @page-change="pageChangeHandler"-->
<!--                      :classMap='{-->
<!--                   "componentClass": "pagination-bottom border-top pt-2",-->
<!--                   "list": "pagination justify-content-center pagination-sm",-->
<!--                   "element": "page-item ",-->
<!--                   "elementDisabled": "disabled",-->
<!--                   "elementActive": "active",-->
<!--                   "page": "page-link"  }' />-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->

              <!--                   v-on:click="setStartForMultiShift"-->
              <div class="row pb-2" id="simple_photo_checkbox">
<!--                <XXLPhotoModal v-bind:photoIDCollection='photos'></XXLPhotoModal>-->
                <div class="col-xl-4 col-lg-6 col-md-6 col-sm-12 pl-0 pr-md-1 pr-lg-2" v-for="(img , index) in photos" :key="img.pdphotoid" :data-blockindex="index">

<!--                  v-on:click.shift="selectMultipleOnShiftKey(img , index, $event)"-->
<!--                  v-on:click.ctrl="multiselectOnControlKey(img , index, $event, 'ctrl')"-->
<!--                  v-on:click.meta="multiselectOnControlKey(img , index, $event, 'Click')"-->
                  <div  class="simple-photo"
                        @click="setSliderImages(img , index, $event, 'add')"
                        ref="img"
                        :photo_id='img.id'
                        :class="{activeImg : currentSliderImg.id === img.pdphotoid && (!isDetailsImagesSelectable && !isSelecteAble), isBottomNav: isSelecteAble}"
                        :data-index="index"
                        >

<!--                    <photodetail :imgdata="img" :isEdit="isEdit" :index="index" @enableEditmode="enableEditmode" :photo_id="img.id"></photodetail>-->
                    <photodetail :imgdata="img" :index="index" :photo_id="img.id"></photodetail>

<!--                    <Popup :photo="img" :creators="creators" :isSelecteAble="isSelecteAble"></Popup>-->
<!--                    <input-->
<!--                      type="checkbox"-->
<!--                      class="d-none"-->
<!--                      v-model="detailsSelectedImages"-->
<!--                      :id="'image'+img.pdphotoid"-->
<!--                      :value="img"-->
<!--                      :disabled="(!isDetailsImagesSelectable && !isSelecteAble)"-->
<!--                    />-->
<!--                    <label :for="'image'+img.pdphotoid" class="w-100 h-100">-->
<!--                      <div data-aspect-ratio="4:3">-->
<!--                        <div v-bind:style="{ 'backgroundImage': 'url(' + img.src + ')' }"-->
<!--                             :alt="img.origname"-->
<!--                             :data-value="img.pdphotoid"-->
<!--                             :data-index="index"-->
<!--                             :data-photoid="img.pdphotoid"-->
<!--                             :data-runid="img.runid"-->
<!--                             :photo_id='img.id'-->
<!--                             @dblclick="showModal(img,photos)"-->
<!--                             ref="img"></div>-->
<!--                      &lt;!&ndash;                <img class="img-fluid" :src="photo.src" alt="img1" :data-index="index">&ndash;&gt;-->
<!--                      </div>-->
<!--                    </label>-->

<!--                    <div class="has-gps" v-if="isEdit && img.exifhasgps"><img src="@/assets/images/has-gps.png" /></div>-->
<!--                    <div class="has-planlocation" v-if="isEdit && img.inplan"><img src="@/assets/images/has-planlocation.png" /></div>-->
<!--                    <div class="has-tags" v-if="isEdit && img.params.length"><img src="@/assets/images/has-tags.png" /></div>-->
<!--                    <div class="has-description" v-if="isEdit && img.description"><img src="@/assets/images/has-description.png" /></div>-->
<!--                    <div class="has-memos" v-if="isEdit && img.memos.length"><img src="@/assets/images/has-memos.png" /></div>-->

<!--                    <div class="simple-photo-option">-->
<!--                      <ul>-->
<!--                        <li>Nr.{{img.runid}}</li>-->
<!--                        <li>|</li>-->
<!--                        <li>{{img.photodateBydot}}</li>-->
<!--                        <li>|</li>-->
<!--                        <li>{{img.photodateBytime}} Uhr</li>-->
<!--                      </ul>-->
<!--                    </div>-->
                  </div>
                </div>
              </div>

              <div class="row position-sticky pt-1 bg-white border-top shadow pagination" style="bottom: 0;" v-if="$store.state.photo.TPage > '1'">
                <div class="col-xl-3 pt-2 col-lg-4 pr-lg-0 pr-0 text-xl-left text-center pl-1">
                  <span class="pl-1 font-10" v-if="$store.state.photo.LEnd < $store.state.photo.filtered">{{$store.state.photo.LStart}} bis {{($store.state.photo.LEnd )}} von  {{($store.state.photo.filtered)}} Fotos</span>
                  <span class=" font-10" v-if="$store.state.photo.LEnd > $store.state.photo.filtered">{{$store.state.photo.LStart}} bis {{($store.state.photo.filtered )}} von  {{($store.state.photo.filtered)}} Fotos</span>
                </div>
                <div class="col-xl-6 col-lg-8 text-center">
                  <div class="p-1">
                    <sliding-pagination
                      :current="$store.state.photo.page"
                      :total="$store.state.photo.TPage"
                      @page-change="pageChangeHandler"
                      :classMap='{
                   "componentClass": "pagination-bottom border-top pt-2",
                   "list": "pagination justify-content-center pagination-sm",
                   "element": "page-item ",
                   "elementDisabled": "disabled",
                   "elementActive": "active",
                   "page": "page-link"  }' />
                  </div>
                </div>
              </div>
            </div>

              <details-single-photo v-if="!isDetailsImagesSelectable"/>

              <details-multi-photos v-if="isDetailsImagesSelectable"/>

          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12 pl-none pr-0 pl-xl-2 pl-lg-1">
        <div class="right-sidebar" style="height:100%;">
          <!-- display on mobile only -->
          <div class="container-fluid d-block d-sm-none">
            <div class="button-areas">
              <div class="row border-bottom pt-2 pb-1">
                <div class="right-btn col-xl-6 col-lg-6 col-md-6 text-left">
                  <button type="button" class="btn btn-light">
                    <img class="plus-img" src="@/assets/images/download.png" alt="img">
                    Plan herunterladen
                  </button>
                  <button type="button" class="btn btn-light ml-2" id="edit-sidebtn">
                    <img class="plus-img" src="@/assets/images/bpen.png" alt="ProjectImage"> Bearbeiten</button>
                </div>
              </div>
            </div>
          </div>
          <!-- end -->
          <DetailsFilters/>
        </div>
      </div>
    </div>
    <SliderDetails ref="sliderDetails" v-show="showSliderView"/>
  </div>
</template>

<script>
import SliderDetails from './SliderDetails'
import DetailsFilters from './DetailsFilters'
import SlidingPagination from 'vue-sliding-pagination'
import DetailsMultiPhotos from './DetailsMultiPhotos'
import DetailsSinglePhoto from './DetailsSinglePhoto'
// import PhotoModal from '../../projects/PhotoModal'
import {mapState} from 'vuex'
import Popup from './infoPopup'
import photodetail from './subitems/photodetail'

export default {
  name: 'Details',
  data () {
    return {
      sliderImages: [],
      currentImage: 0,
      is_loading: false,
      is_slider_set: false,
      photo_url: '',
      is_multiselect: false,
      detailsPhotoSelection: [],
      lastClickedImage: ''
      // bus: new Vue()
    }
  },
  components: {
    Popup,
    DetailsFilters,
    SliderDetails,
    SlidingPagination,
    DetailsMultiPhotos,
    DetailsSinglePhoto,
    photodetail
    // PhotoModal
  },
  computed: {
    ...mapState({
      currentSliderImg: state => state.photo.slider_active_image,
      photos: state => state.photo.photos,
      editIndex: state => state.photo.editPhoto,
      isEditPhoto: state => state.photo.isEditPhoto,
      showSliderView: state => state.photo.showSliderView,
      isDetailsImagesSelectable: state => state.photo.isDetailsImagesSelectable
    }),
    creators () {
      return this.$store.state.creators
    },

    isEdit: {
      get () {
        return this.$store.state.photo.isEdit
      },
      set (val) {
        this.$store.commit('toggleEdit', val)
      }
    },

    isSelecteAble: {
      get () {
        return this.$store.state.photo.isBottomNav
      }
    },

    selectedImages: {
      get () {
        return this.$store.state.photo.selectedPhotos
      },
      set (val) {
        this.$store.commit('setSelectedPhotos', val)
      }
    },

    detailsSelectedImages: {
      get () {
        if (this.isSelecteAble) {
          return this.$store.state.photo.selectedPhotos
        } else {
          return this.$store.state.photo.detailsSelectedImages
        }
      },
      set (val) {
        if (this.isSelecteAble) {
          this.$store.commit('setSelectedPhotos', val)
        } else {
          this.$store.commit('setDetailsSelectedImages', val)
        }
      }
    }
  },
  mounted () {
    let _this = this
    // this.enableEditmode()

    if (!this.is_slider_set) {
      // this.isEdit = this.$store.state.photo.isEditPhoto
      this.setSliderImages(this.photos[this.editIndex === null ? 0 : this.editIndex])
      this.lastClickedImage = "0"
    }

    // console.log('isEditthis.$store.state.photo.editPhoto C', this.$store.state.photo.editPhoto, this.isEdit);
    // console.log('isEditthis.$store.state.photo.isEditPhoto C', this.$store.state.photo.isEditPhoto, this.isEdit);

  },
  methods: {
    enableEditmode() {
      // this.isEdit = this.$store.state.photo.isEditPhoto
    },
    // START XXL VIEW
    showModal (photoXXL, photosXXL) {
      // this.getfileImage_xxl(photoXXL)
      // this.ScrollZoom($('#image_container'),4,0.25);
      /** Here the Code from the API Picture in Full Size **/
      // Enable the Modal - View if clicked on Picture
      // $('#imagemodal').modal('show')
      // this.$store.state.photo.currentModalPhoto = photoXXL

      console.log('showModal in Details.vue')
      this.$parent.loadXXL(photoXXL)
    },

    setStartForMultiShift (event) {
      // if (this.isEdit) {
      if (!event.shiftKey) {
        this.lastClickedImage = event.target.getAttribute('data-index')
        console.log('Shift CLICK start set to', this.lastClickedImage)
      }
      // }
    },
    // Select MultiPhotos On Click Of Shift + Clicked
    selectMultipleOnShiftKey (imgId, index = null, event = null, target = null) {

      if(this.$store.state.photo.isBottomNav) {
        return true
      }
      // if (!event || event.shiftKey !== true) {
      if (!event || !event.shiftKey) {
        return false
      }
      console.log('CLICKED KEY selectMultipleOnShiftKey', 'SHIFT', event.shiftKey);

      if (this.lastClickedImage == '') {
        this.lastClickedImage = event.target.getAttribute('data-index')
        return false
      }

      if (event.shiftKey) {
        if (this.isEdit || this.isSelecteAble) {

          console.log('CLICKED KEY', 'SHIFT', 'Start selection');
          this.$store.commit('toggleDetailsImagesSelectable', true)
          if (this.isDetailsImagesSelectable) {
            let obj = this
            let index = event.target.getAttribute('data-index')

            if (index === null) return false

            let start = 0
            if (this.lastClickedImage >= 0) {
              start = this.lastClickedImage
            }

            if (parseInt(start) > parseInt(index)) {
              var estart = index
              index = start
              start = estart
              // start = event.target.getSvgAttributes('data-index')
            }

            index = parseInt(index)

            if(this.$store.state.photo.isBottomNav) {
              index--
            }

            for (let i = start; i <= index; i++) {
              if (!(obj.detailsSelectedImages.find((item) => item.pdphotoid == obj.photos[i].pdphotoid))) {
                obj.detailsSelectedImages.push(obj.photos[i])
              }
            }

            if (!(obj.detailsSelectedImages.find((item) => item.pdphotoid == obj.photos[index].pdphotoid))) {
              obj.detailsSelectedImages.push(obj.photos[index])
            }

            this.setCurrentImageIndex(index)
            let payload = { id: this.$route.params.id, img_id: imgId.pdphotoid }
            this.$store.dispatch('getImageDetails', payload)
            this.$store.commit('setActiveImage', imgId)
          }
          return true
        }
      }
      return false
    },

    multiselectOnControlKey (imgId, index = null, event = null, btype = null, target = null) {

      if ( (event && (event.ctrlKey || event.metaKey)) || this.$store.state.photo.isBottomNav) {


        if(this.$store.state.photo.isBottomNav) {
          return true
        }

        let idex = this.detailsSelectedImages.findIndex((item) => item.pdphotoid == imgId.pdphotoid)


        if (idex >= 0) {
          // Remove Item
          this.detailsSelectedImages.splice(idex, 1)
        } else {
          // Add Item
          this.detailsSelectedImages.push(imgId)
        }

        // If CTRL OR META hold and NOT isBottomNav
        if((event && (event.ctrlKey || event.metaKey)) && !this.isSelecteAble) {
          if (!this.$store.state.photo.isDetailsImagesSelectable) {
            this.detailsSelectedImages.push(this.$store.state.photo.active_image)
          }
          this.$store.commit('toggleDetailsImagesSelectable', true)

          if (this.detailsSelectedImages.length <= 0) {
            this.$store.state.photo.isDetailsImagesSelectable = false
          }
        } else if(this.isSelecteAble) {
          // Is Selectable
          if (!this.$store.state.photo.isDetailsImagesSelectable) {
            this.detailsSelectedImages.push(this.$store.state.photo.active_image)
          }
          this.$store.commit('toggleDetailsImagesSelectable', true)
        }

        this.setCurrentImageIndex(index)
        // if(this.isSelecteAble) {
        //   return false
        // }

        let payload = {id: this.$route.params.id, img_id: imgId.pdphotoid}
        this.$store.dispatch('getImageDetails', payload)
        this.$store.commit('setActiveImage', imgId)


        return true
      }
      return false
    },

    setEditMode() {
      // console.log('setEdit')
      // this.isEdit = true
    },
    // Function To set slider images
    setSliderImages (imgId, index = null, event = null, action = null) {
      // console.log('emited c', imgId, index, event, action)
      if ( event && (event.target.tagName === 'I' || event.target.tagName === 'BUTTON') && !event.target.classList.contains('fa-edit') ) {
        return;
      }

      console.log('isEdit this.$store.state.photo.isEdit', this.$store.state.photo.isEdit)
      // console.log('emited d', imgId, index, event, action)
      if(action == 'setedit') {

        console.log('isEdit setEdit')

        this.$store.state.photo.isEdit = true
      }
      // Action run if Shift is hold
      // if (event && event.shiftKey ) {
      if (this.selectMultipleOnShiftKey(imgId, index, event)) {
        // console.log('Clicked Shift return')
        return
      }

      if (event && !event.shiftKey) {
        this.lastClickedImage = event.target.getAttribute('data-index')
      }
      if (this.multiselectOnControlKey(imgId, index, event, 'auto')) {
        return
      }


      // Action run if ctrl is hold
      // if (this.multiselectOnControlKey(imgId, index, event, 'auto')) {
      //   return
      // }

      // Stop if Shift, CTRL or CMD hold.
      if (event && ( event.shiftKey || event.ctrlKey || event.metaKey) ) {
        return
      }
      // console.log('Clicked no previous')

      // check if image in list

      this.setCurrentImageIndex(index)

      // If in Edit mode delete reset selected
      if(this.isEdit) {
        this.detailsSelectedImages = []
      }

      let payload = { id: this.$route.params.id, img_id: imgId.pdphotoid }
      this.$store.dispatch('getImageDetails', payload)

      let test = this.checkImg(imgId.pdphotoid) ? null : this.setImage(imgId.pdphotoid)
      this.is_slider_set = true
      this.$store.commit('setActiveImage', imgId)

    },

    // Handle Pagination
    pageChangeHandler (selectedPage) {
      this.$store.state.photo.page = selectedPage
      this.$root.$emit('pageChangeHandler', selectedPage)
    },
    // Move to previous image method
    previousImage () {
      if (this.$store.state.photo.dirty) {
        return
      }
      if (this.currentImage <= 0) {
        // this.currentImage = this.photos.length - 1
        this.setCurrentImageIndex('0')
        // this.currentImage = 0
      } else {
        this.setCurrentImageIndex(--this.currentImage)
      }
      let img = this.photos[this.currentImage]
      this.setSliderImages(img)
    },

    // Move to next image method
    nextImage () {
      console.log('IsDirty', this.$store.state.photo.dirty)
      if (this.$store.state.photo.dirty) {
        return
      }
      console.log('Current Next Image', this.currentImage === (this.photos.length - 1))
      if (this.currentImage === (this.photos.length - 1)) {
        // this.currentImage = 0
        this.setCurrentImageIndex('0')
      } else {
        this.setCurrentImageIndex(++this.currentImage)
        // this.currentImage += 1
      }
      let img = this.photos[this.currentImage]
      this.setSliderImages(img)
    },


    setCurrentImageIndex (index) {

      let currentindex = index
      if(currentindex == null) {
        currentindex = this.currentImage
      }
      if (index == null) index = this.currentImage
      this.currentImage = index
    },

    // set image If its already loaded for Slider
    checkImg (id) {
      let img = null
      img = this.sliderImages.find(item => item.pdphotoid === id)
      return img ? this.$store.commit('sliderActiveImage', img) : false
    },

    // get image for Slider
    async setImage (imgId) {
      let obj = this
      obj.is_loading = true
      // obj.photo_url = `${process.env.VUE_APP_BASE_URL}/getfile/photo/${imgId}/1500x1500/org`
      obj.photo_url = `${process.env.VUE_APP_GET_METHOD_URL}img&projectid=${this.$route.params.id}&id=${imgId}&token=${localStorage.sessiontoken}`
      let img = {id: imgId, src: '', projectid: this.$route.params.id}
      await fetch(obj.photo_url, {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid
        }
      })
        .then(response => response.blob())
        .then(response => {
          let reader = new FileReader()
          reader.readAsDataURL(response)
          reader.onload = function () {
            img.src = reader.result
            // obj.sliderImages.push(img)
            obj.$store.commit('sliderActiveImage', img)
            obj.is_loading = false
          }
        }).catch((error) => {
          obj.is_loading = false
          console.error('Error:', error)
        })
    },

    toggleSliderView () {
      this.$store.commit('toggleSliderView')
      // this.bus.$emit('loadPreview')
    }
  },
  watch: {
    'editIndex': function (val){
      console.log('editIndex changed! LL', val)
      this.setSliderImages(this.photos[val])
    },
    'isEditPhoto': function(val) {
      console.log('editPhoto changed! LL', this.editIndex)
      this.setSliderImages(this.photos[this.editIndex])
    }
  }
}
</script>
<style scoped>
  .activeImg{
    border: 5px solid #4c76e2;
    border-radius: 5px;
  }
  .btn-expand{
    position: absolute;
    right: 15px;
    top: 1px;
  }
  #image_container{
    height: calc(100vh - 159px);
  }
  img.img.img-fluid{
    max-height: -webkit-fill-available !important;
  }
  .nooverflow {
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/photo/components/Details.vue